/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_cart_completion_suggestions = /** @type {(inputs: {}) => string} */ () => {
	return `Objevte také :`
};

const da_cart_completion_suggestions = /** @type {(inputs: {}) => string} */ () => {
	return `Se også:`
};

const de_cart_completion_suggestions = /** @type {(inputs: {}) => string} */ () => {
	return `Entdecken Sie auch:`
};

const en_cart_completion_suggestions = /** @type {(inputs: {}) => string} */ () => {
	return `Also explore:`
};

const es_cart_completion_suggestions = /** @type {(inputs: {}) => string} */ () => {
	return `También te puede interesar:`
};

const fr_cart_completion_suggestions = /** @type {(inputs: {}) => string} */ () => {
	return `Découvrez aussi :`
};

const hu_cart_completion_suggestions = /** @type {(inputs: {}) => string} */ () => {
	return `Fedezd fel azt is :`
};

const it_cart_completion_suggestions = /** @type {(inputs: {}) => string} */ () => {
	return `Scopri anche:`
};

const nl_cart_completion_suggestions = /** @type {(inputs: {}) => string} */ () => {
	return `Misschien ook interessant:`
};

const pl_cart_completion_suggestions = /** @type {(inputs: {}) => string} */ () => {
	return `Zobacz także:`
};

const pt_cart_completion_suggestions = /** @type {(inputs: {}) => string} */ () => {
	return `Veja também:`
};

const sv_cart_completion_suggestions = /** @type {(inputs: {}) => string} */ () => {
	return `Upptäck också:`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cart_completion_suggestions = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cart_completion_suggestions(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cart_completion_suggestions", locale)
	if (locale === "cs") return cs_cart_completion_suggestions(inputs)
	if (locale === "da") return da_cart_completion_suggestions(inputs)
	if (locale === "de") return de_cart_completion_suggestions(inputs)
	if (locale === "en") return en_cart_completion_suggestions(inputs)
	if (locale === "es") return es_cart_completion_suggestions(inputs)
	if (locale === "fr") return fr_cart_completion_suggestions(inputs)
	if (locale === "hu") return hu_cart_completion_suggestions(inputs)
	if (locale === "it") return it_cart_completion_suggestions(inputs)
	if (locale === "nl") return nl_cart_completion_suggestions(inputs)
	if (locale === "pl") return pl_cart_completion_suggestions(inputs)
	if (locale === "pt") return pt_cart_completion_suggestions(inputs)
	return sv_cart_completion_suggestions(inputs)
};